import {observer} from 'mobx-react';
import React from 'react';
import ReactInputMask from 'react-input-mask';
import {InputAutoWidth} from '../../../../lib/components';
import {UserSearchStore} from './UserSearchStore';

const font = 'normal 400 14px Roboto';

const datePlaceholder = 'yyyy-mm-dd';
const timePlaceholder = 'hh:mm';

@observer
export class UserSearchControls extends React.Component<{ store: UserSearchStore }> {
  render() {
    const store = this.props.store;
    const isLoading = store.resultState?.isPending === true;
    const isResolved = store.resultState?.isResolved === true;
    return (
      <div className="row align-items-end">
        <div className="col-auto">
          <div className="form-group user-search-string">
            <label>Search string</label>
            <InputAutoWidth type="text" className="form-control"
                            font={font}
                            value={store.userFilter.value}
                            onChange={store.userFilter.onChangeHandler}/>
          </div>
        </div>
        <div className="col-auto">
          <div className="form-group user-available-date">
            <label>Date</label>
            <ReactInputMask className="form-control date"
                            mask="9999-99-99"
                            value={store.dateFilter.value}
                            onChange={store.dateFilter.onChangeHandler}
                            placeholder={datePlaceholder}/>
          </div>
        </div>
        <div className="col-auto">
          <div className="form-group user-available-time">
            <label>Time</label>
            <ReactInputMask className="form-control time"
                            mask="99:99"
                            value={store.timeFilter.value}
                            onChange={store.timeFilter.onChangeHandler}
                            placeholder={timePlaceholder}/>
          </div>
        </div>
        <div className="col-auto ml-auto">
          <div className="btn-group">
            <button type="button" className="btn btn-primary"
                    disabled={isLoading}
                    onClick={store.searchUsers}>
              Search
            </button>
            <button type="button" className="btn btn-primary"
                    disabled={!isResolved}
                    onClick={store.toggleExpand}>
              <i className={!isResolved || store.expanded ? 'fas fa-minus' : 'fas fa-plus'}/>
            </button>
          </div>
        </div>
      </div>);
  }
}
